// extracted by extract-css-chunks-webpack-plugin
module.exports = {"map":"map__map--1x48g","ico-tap":"map__ico-tap--eG-kU","icoTap":"map__ico-tap--eG-kU","disabled":"map__disabled--1zGAL","pin":"map__pin--T5Hcq","ico":"map__ico--W8Z92"};